import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Stepper, Step, StepLabel } from '@material-ui/core';
import ColorlibConnector from './ColorLibConnector';
import ColorlibStepIcon from './ColorlibStepIcon';
import { formatDate } from '../../../../../helpers/DateFormatter';
import { useTrackingStepperStyles } from './styles';

const TrackingStepper = ({ ...props }) => {
  const { history, mobile, failed } = props;
  const classes = useTrackingStepperStyles();
  const [activeStep, setActiveStep] = useState(1);

  useEffect(() => {
    for (let i = history.length - 1; i > 0; i--) {
      if (history[i].date) {
        setActiveStep(i);
        break;
      }
    }
  }, [history]);

  const setDate = (date) => {
    return date ? formatDate(date) : '';
  };

  return (
    <div className={classes.root}>
      <Stepper
        alternativeLabel={!mobile}
        activeStep={activeStep}
        orientation={mobile ? 'vertical' : 'horizontal'}
        connector={<ColorlibConnector failed={failed} />}
      >
        {history.map((historyNode) => (
          <Step key={historyNode.label}>
            <StepLabel
              className={classes.label}
              StepIconComponent={ColorlibStepIcon}
              StepIconProps={{ label: historyNode.label, failed }}
            >
              <b>{historyNode.label}</b>
              <br />
              {setDate(historyNode.date)}{' '}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
};

TrackingStepper.propTypes = {
  mobile: PropTypes.bool,
  failed: PropTypes.bool,
  history: PropTypes.array,
};

export default TrackingStepper;
